export default {
  state: {
    modalProdSelection: {
      isVisible: false,
      products: [],
      buttons: [
        {
          buttonText: 'Cancelar',
          buttonAction: ''
        },
        {
          buttonText: 'Confirmar',
          buttonAction: 'modalProductSelection'
        }
      ],
      text: '',
      icon: '',
      groupItens: []
    }
  },
  getters: {
    modalProdSelection: (state) => state.modalProdSelection,
    getGroupItens: (state) => state.groupItens,
    getFirstGroupIten: (state) => state.modalProdSelection.groupItens
  },
  mutations: {
    removeGroupItens (state) {
      state.modalProdSelection.groupItens.shift()
    },
    removeProductFromList (state, code) {
      state.modalProdSelection.products = state.modalProdSelection.products.filter(i => i !== code)
    },
    addGroupItens (state, data) {
      state.modalProdSelection.groupItens.push(data)
    },
    showModalProdSelection (state, data) {
      state.modalProdSelection.text = data.text
      state.modalProdSelection.icon = data.icon
      state.modalProdSelection.products = data.products
      state.modalProdSelection.groupItens = []

      if (data.open) {
        state.modalProdSelection.isVisible = true
      }
    },
    closeModalProdSelection (state) {
      state.modalProdSelection.isVisible = false
    }
  },
  actions: {
    removeGroupItens ({ commit }) {
      commit('removeGroupItens')
    },
    removeProductFromList ({ commit }, code) {
      commit('removeProductFromList', code)
    },
    addGroupItens ({ commit }, data) {
      commit('addGroupItens', data)
    },
    showModalProdSelection ({ commit }, data) {
      commit('showModalProdSelection', data)
    },
    closeModalProdSelection ({ commit }) {
      commit('closeModalProdSelection')
    }
  }
}
